/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Allocation_Form_Cycle_DurationInputs */

const en_admin_allocation_form_cycle_duration = /** @type {(inputs: Admin_Allocation_Form_Cycle_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per`)
};

const de_admin_allocation_form_cycle_duration = /** @type {(inputs: Admin_Allocation_Form_Cycle_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pro`)
};

const es_admin_allocation_form_cycle_duration = /** @type {(inputs: Admin_Allocation_Form_Cycle_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por`)
};

const fr_admin_allocation_form_cycle_duration = /** @type {(inputs: Admin_Allocation_Form_Cycle_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`par`)
};

const nl_admin_allocation_form_cycle_duration = /** @type {(inputs: Admin_Allocation_Form_Cycle_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per`)
};

/** @type {(inputs: Admin_Allocation_Form_Cycle_DurationInputs) => LocalizedString} */
const it_admin_allocation_form_cycle_duration = en_admin_allocation_form_cycle_duration;

/** @type {(inputs: Admin_Allocation_Form_Cycle_DurationInputs) => LocalizedString} */
const pt_br2_admin_allocation_form_cycle_duration = en_admin_allocation_form_cycle_duration;

/** @type {(inputs: Admin_Allocation_Form_Cycle_DurationInputs) => LocalizedString} */
const pl_admin_allocation_form_cycle_duration = en_admin_allocation_form_cycle_duration;

/** @type {(inputs: Admin_Allocation_Form_Cycle_DurationInputs) => LocalizedString} */
const hu_admin_allocation_form_cycle_duration = en_admin_allocation_form_cycle_duration;

/** @type {(inputs: Admin_Allocation_Form_Cycle_DurationInputs) => LocalizedString} */
const ro_admin_allocation_form_cycle_duration = en_admin_allocation_form_cycle_duration;

/**
* | output |
* | --- |
* | "per" |
*
* @param {Admin_Allocation_Form_Cycle_DurationInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocation_form_cycle_duration = /** @type {((inputs?: Admin_Allocation_Form_Cycle_DurationInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocation_Form_Cycle_DurationInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocation_form_cycle_duration(inputs)
	if (locale === "de") return de_admin_allocation_form_cycle_duration(inputs)
	if (locale === "es") return es_admin_allocation_form_cycle_duration(inputs)
	if (locale === "fr") return fr_admin_allocation_form_cycle_duration(inputs)
	if (locale === "nl") return nl_admin_allocation_form_cycle_duration(inputs)
	if (locale === "it") return it_admin_allocation_form_cycle_duration(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocation_form_cycle_duration(inputs)
	if (locale === "pl") return pl_admin_allocation_form_cycle_duration(inputs)
	if (locale === "hu") return hu_admin_allocation_form_cycle_duration(inputs)
	return ro_admin_allocation_form_cycle_duration(inputs)
});
export { admin_allocation_form_cycle_duration as "admin.allocation_form.cycle_duration" }